// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createEmissionsPartSearch} from '../../shared/repositories';

export const fetchEmissionsQualification = postArgs =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createEmissionsPartSearch(postArgs);

            const hasNoResult = !data.qualifyForEmissions;

            dispatch({
                data,
                type: actions.CREATE_EMISSIONS_PART_SEARCH_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetEmissionsPartSearch = () => ({
    type: actions.RESET_EMISSIONS_PART_SEARCH_REPORT
});



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/action-creators/report.js